export const GET_FLEETS: string = 'src/pages/fleets/GET_FLEETS';
export const GET_FLEETS_SUCCESS: string =
  'src/pages/fleets/GET_FLEETS_SUCCESS';
export const GET_FLEETS_FAILED: string =
  'src/pages/fleets/GET_FLEETS_FAILED';

export const CREATE_FLEETS: string = 'src/pages/fleets/CREATE_FLEETS';
export const CREATE_FLEETS_SUCCESS: string =
  'src/pages/fleets/CREATE_FLEETS_SUCCESS';
export const CREATE_FLEETS_FAILED: string =
  'src/pages/fleets/CREATE_FLEETS_FAILED';

export const GET_FLEET: string = 'src/pages/fleets/GET_FLEET';
export const GET_FLEET_SUCCESS: string =
  'src/pages/fleets/GET_FLEET_SUCCESS';
export const GET_FLEET_FAILED: string =
  'src/pages/fleets/GET_FLEET_FAILED';

export const UPDATE_FLEET: string = 'src/pages/fleets/UPDATE_FLEET';
export const UPDATE_FLEET_SUCCESS: string =
  'src/pages/fleets/UPDATE_FLEET_SUCCESS';
export const UPDATE_FLEET_FAILED: string =
  'src/pages/fleets/UPDATE_FLEET_FAILED';

export const UPDATE_FLEET_STATUS: string = 'src/pages/fleets/UPDATE_FLEET_STATUS';
export const UPDATE_FLEET_STATUS_SUCCESS: string =
  'src/pages/fleets/UPDATE_FLEET_STATUS_SUCCESS';
export const UPDATE_FLEET_STATUS_FAILED: string =
  'src/pages/fleets/UPDATE_FLEET_STATUS_FAILED';

export const GET_VEHICLE_PREFERRED_SOURCES: string =
  'src/pages/fleets/GET_VEHICLE_PREFERRED_SOURCES';
export const GET_VEHICLE_PREFERRED_SOURCES_SUCCESS: string =
  'src/pages/fleets/GET_VEHICLE_PREFERRED_SOURCES_SUCCESS';
export const GET_VEHICLE_PREFERRED_SOURCES_FAILED: string =
  'src/pages/fleets/GET_VEHICLE_PREFERRED_SOURCES_FAILED';

export const UPDATE_VEHICLE_PREFERRED_SOURCES: string =
  'src/pages/fleets/UPDATE_VEHICLE_PREFERRED_SOURCES';
export const UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS: string =
  'src/pages/fleets/UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS';
export const UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED: string =
  'src/pages/fleets/UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED';

export const GET_CENTERS: string = 'src/pages/fleets/CENTERS';
export const GET_CENTERS_SUCCESS: string =
  'src/pages/fleets/GET_CENTERS_SUCCESS';
export const GET_CENTERS_FAILED: string =
  'src/pages/fleets/GET_CENTERS_FAILED';

export const GET_FLEET_SHIFTS: string = 'src/pages/fleets/GET_FLEET_SHIFTS';
export const GET_FLEET_SHIFTS_SUCCESS: string =
  'src/pages/fleets/GET_FLEET_SHIFTS_SUCCESS';
export const GET_FLEET_SHIFTS_FAILED: string =
  'src/pages/fleets/GET_FLEET_SHIFTS_FAILED';

export const UPDATE_FLEET_SHIFTS: string =
  'src/pages/fleets/UPDATE_FLEET_SHIFTS';
export const UPDATE_FLEET_SHIFTS_SUCCESS: string =
  'src/pages/fleets/UPDATE_FLEET_SHIFTS_SUCCESS';
export const UPDATE_FLEET_SHIFTS_FAILED: string =
  'src/pages/fleets/UPDATE_FLEET_SHIFTS_FAILED';
